import React, { useEffect } from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { cn } from '@/lib/utils';

const Notification = ({ message, type = 'success', onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="fixed top-4 right-4 z-50 animate-in fade-in slide-in-from-top-2">
      <div className={cn(
        "rounded-lg px-4 py-3 shadow-lg",
        "flex items-center gap-2",
        type === 'success' && "bg-green-500/10 text-green-400 border border-green-500/20",
        type === 'error' && "bg-red-500/10 text-red-400 border border-red-500/20"
      )}>
        {type === 'success' && <CheckCircle2 className="w-4 h-4" />}
        {type === 'error' && <X className="w-4 h-4" />}
        <p className="text-sm">{message}</p>
        <button 
          onClick={onClose}
          className="ml-2 text-current opacity-70 hover:opacity-100"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default Notification; 